import { Routes } from '@angular/router';

export const STATIONS_ROUTES: Routes = [
  {
    path: 'stations',
    loadComponent: () =>
      import('./stations-list/stations-list.component')
        .then(m => m.StationsListComponent),
  },
  {
    path: 'stations/create',
    loadComponent: () =>
      import('./stations-form/stations-form.component')
        .then(m => m.StationsFormComponent),
  },
  {
    path: 'stations/edit/:id',
    loadComponent: () =>
      import('./stations-form/stations-form.component')
        .then(m => m.StationsFormComponent),
  },
];
